var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ChapterRoleIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 30,
    glyphHeight: 67
  }), React.createElement("path", {
    d: "M0.599976 48.9826C0.599976 37.087 6.65215 30.6174 16.0435 30.6174C22.513 30.6174 26.4782 33.1218 29.1913 38.7566L22.7217 42.0957C21.8869 39.174 20.0087 37.2957 16.2521 37.2957C11.8695 37.2957 8.73911 40.2174 8.73911 45.8522V51.487C8.73911 56.9131 11.6608 60.0435 16.2521 60.0435C20.0087 60.0435 22.0956 57.7479 23.1391 54.8261L29.4 58.374C26.8956 63.5913 22.7217 66.7218 16.2521 66.7218C6.65215 66.9305 0.599976 60.8783 0.599976 48.9826Z"
  }), React.createElement("path", {
    d: "M15.2087 0.773926C8.32179 0.773926 2.68701 6.40871 2.68701 13.2957C2.68701 20.1826 8.32179 25.8174 15.2087 25.8174C22.0957 25.8174 27.7305 20.1826 27.7305 13.2957C27.7305 6.40871 22.0957 0.773926 15.2087 0.773926ZM13.1218 19.5565L6.86092 13.2957L8.94788 11.2087L13.1218 15.3826L21.4696 7.0348L23.5566 9.12175L13.1218 19.5565Z"
  }));
};
export var ChapterRoleIconGlyph = function (props) {
  return React.createElement(ChapterRoleIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};